import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useRouteQueryKey} from '@github-ui/react-core/future/use-route-query-key'
import {pullRequestsLayoutRoute} from '../routes/layout-route'
import {useInvalidateOnAliveUpdate} from '@github-ui/use-invalidate-on-alive-update'
import type {PullRequestAliveData} from './use-refetch-on-alive-update'

const filter = (data: PullRequestAliveData) => Boolean(data.event_updates?.tab_counts_updated)
const emptyQueryKey = [] as const

/**
 * Subscribe to live updates for tab counts.
 */
export function useTabCountLiveUpdates() {
  const {
    data: {aliveChannels},
  } = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')

  const tabCountsQueryKey = useRouteQueryKey(pullRequestsLayoutRoute, 'tabCounts')
  useInvalidateOnAliveUpdate(tabCountsQueryKey ? aliveChannels.pullRequest : '', tabCountsQueryKey ?? emptyQueryKey, {
    filter,
  })
}
